import { css } from "@emotion/core";
import { DESIGN_TOKEN } from "Config/design_token";
import { PROFILE_STYLES } from "./profile";
import { SCHEDULE_STYLES } from "./schedule";
import { MAX_READABLE_WIDTH } from "./constants";
require('Views/assets/bullet.svg');

/**
 * Styles specific to Wordpress.  These target either classes generated by
 * Wordpress itself, or make style adjustments based on the markup structure
 * dictated by Wordpress.
 */
export const WORDPRESS_STYLES = css`
  p + h1,
  p + h2,
  p + h3,
  p + h4,
  p + h5,
  p + h6 {
    margin-top: 4rem;
  }

  ul {
    margin-bottom: 1.4rem;
    width: 100%;
    max-width: ${MAX_READABLE_WIDTH}
  }
  ul li {
    background-image: url('/wp-content/themes/sandpiper/img/bullet.svg');
    background-repeat: no-repeat;
    background-position: 0rem 0.6rem;
    
    margin: 0rem 0rem 1rem 0rem;
    padding-left: 1.4rem;
    
    font-family: ${DESIGN_TOKEN.fonts.font_1.family};
    font-size: 1.2rem;
    line-height: 1.8rem;

    &:last-of-type {
      margin-bottom: 0rem;
    }
  }

  .wp-block-spacer {
    height: 2rem !important;
  }

  .wp-block-quote {
    padding: 0rem 1rem;
  }
  .wp-block-quote p:last-of-type {
    text-align: right;
    font-style: ${DESIGN_TOKEN.fonts.font_1.style.oblique};
  }

  ${PROFILE_STYLES}

  ${SCHEDULE_STYLES}
`;
